<template>
  <div class="transmission-personalized-setting" v-loading="isLoading">
    <div class="title">
      传单个性化校验
      <span class="transmission-applicable-personnel-setting">
        <span>适用人员：</span>
        <el-radio-group v-if="applicablePersonnel"  v-model="applicablePersonnel.value" @change="handleChange">
          <el-radio :label="1">全部人</el-radio>
          <el-radio :label="2">指定名单</el-radio>
        </el-radio-group>
        <span v-if="applicablePersonnel&&applicablePersonnel.value === 2">
          <el-select
            v-model="applicablePersonnel.personValue"
            placeholder="请选择名单"
            size="mini"
            clearable
            multiple
          >
            <el-option
              v-for="item in applicablePersonnel.configExtends[0]&&applicablePersonnel.configExtends[0].options"
              :key="item.business"
              :label="item.business"
              :value="item.business"
            ></el-option>
          </el-select>
        </span>
      </span>
    </div>
    <div
      class="setting-item">
      <!-- v-if="
        orderDuplicationRiskCheckConfig &&
        orderSizeCheckConfig &&
        panelProtrudingCurvedTabletopCheckConfig &&
        sideAndTopPanelHeightUnevennessCheckConfig &&
        topAsHangingCabinetCheckConfig
      " -->
      <div class="config-row">
        <div class="config-header">
          <span>开启【订单重复风险检测】</span>
          <el-switch
            v-model="orderDuplicationRiskCheckConfig.value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div>
        <div class="config-description">
          说明:针对衣柜订单，按照订单板件PID与已下单订单对比，判断是否存在重复下单风险。若系统判断有重复风险，会在订单传单时做出提醒。
        </div>
      </div>
      <div class="config-row">
        <div class="config-header">
          <span>开启【订单尺寸超长超宽检测】</span>
          <span class="size-inputs">
            <span class="input-group">
              <span class="input-label">电梯可容纳长</span>
              <el-input-number
                :value="getSizeValue('length')"
                @input="setSizeValue('length', $event)"
                placeholder="请输入"
                size="mini"
                :disabled="orderSizeCheckConfig&&orderSizeCheckConfig.value === 'false'"
                :min="0"
                :precision="2"
                :controls="false"
                style="width: 120px"
              ></el-input-number>
              <span class="input-unit">m</span>
            </span>
            <span class="input-group">
              <span class="input-label">宽</span>
              <el-input-number
                :value="getSizeValue('width')"
                @input="setSizeValue('width', $event)"
                placeholder="请输入"
                size="mini"
                :disabled="orderSizeCheckConfig&&orderSizeCheckConfig.value === 'false'"
                :min="0"
                :precision="2"
                :controls="false"
                style="width: 120px"
              ></el-input-number>
              <span class="input-unit">m</span>
            </span>
            <span class="input-group">
              <span class="input-label">深</span>
              <el-input-number
                :value="getSizeValue('height')"
                @input="setSizeValue('height', $event)"
                placeholder="请输入"
                size="mini"
                :disabled="orderSizeCheckConfig&&orderSizeCheckConfig.value === 'false'"
                :min="0"
                :precision="2"
                :controls="false"
                style="width: 120px"
              ></el-input-number>
              <span class="input-unit">m</span>
            </span>
          </span>
          <el-switch
            v-model="orderSizeCheckConfig.value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div>
        <div class="config-description">
          说明:针对订单尺寸超长超宽会产生额外搬运等费用的情况，系统将订单的长宽高尺寸与商场设定的常规尺寸对比，若出现超长超宽风险，会在订单传单时做提醒。
        </div>
      </div>
      <div class="config-row" v-for="item in configFormItemList" :key="item.ruleId">
        <div class="config-header">
          <span>{{item.formDisplayTitle}}</span>
          <el-switch
            v-model="item.value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div>
        <div class="config-description">
          {{item.formDisplayContent}}
        </div>
      </div>
      
      <!-- <div class="config-row">
        <div class="config-header">
          <span>开启【顶柜当吊柜使用检测】</span>
          <el-switch
            v-model="topAsHangingCabinetCheckConfig.value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div>
        <div class="config-description">
          说明:检测顶柜当吊柜使用，即：背板下方无柜体且未配置挂墙五金的情况。
        </div>
      </div>

      <div class="config-row">
        <div class="config-header">
          <span>开启【门板/装饰板突出圆弧台面检测】</span>
          <el-switch
            v-model="panelProtrudingCurvedTabletopCheckConfig.value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div>
        <div class="config-description">
          说明:检测圆弧台面倒角后延伸尺寸不足，导致下方门板/装饰板突出台面的情况。
        </div>
      </div>

      <div class="config-row">
        <div class="config-header">
          <span>开启【侧封板与门板/顶封板高度不平齐检测】</span>
          <el-switch
            v-model="sideAndTopPanelHeightUnevennessCheckConfig.value"
            active-text="是"
            inactive-text="否"
            active-value="true"
            inactive-value="false"
          >
          </el-switch>
        </div>
        <div class="config-description">
          说明:检测侧封板、门板、顶封板高度，对不平齐的情况做出提醒。
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { reqGetCurrentUser } from "@oppein/op-utils";
import {
  productionOrderMarketConfigListByCondition,
  productionOrderMarketConfigSaveOrgConfig,
} from "@/api/checkOrderByCustomer/index";
import { getSpecialBusinessListByPlatformName } from "@/api/designapi/design/special/getSpecialBusinessListByPlatformName/post";
import { postPersonalizedCheckTypeConfigGetListByQry } from "@/api/designordercenter/personalizedCheckTypeConfig/getListByQry/post";


export default {
  name: "TransmissionPersonalizedSetting",
  data() {
    return {
      isLoading: false,
      // 保存完整的配置对象，用于编辑保存
      orderDuplicationRiskCheckConfig: null,
      orderSizeCheckConfig: {},
      topAsHangingCabinetCheckConfig: null,
      panelProtrudingCurvedTabletopCheckConfig: null,
      sideAndTopPanelHeightUnevennessCheckConfig: null,
      applicablePersonnel: null,
      configFormItemList: [],
      marketConfigList: [],
      currentUser: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    handleChange() {
      this.$set(this.applicablePersonnel, 'personValue', []);
    },
    async init() {
      await this.getTransmissionConfig();
      await this.getSpecialBusinessList();
      await this.postPersonalizedCheckTypeConfig();
    },
    async postPersonalizedCheckTypeConfig() {
      try {
        this.isLoading = true;
        const response = await postPersonalizedCheckTypeConfigGetListByQry({
          searchKeyWord: "",
          shelfStatus: 1,
        });
        if (response.status && response.data) {
          // 解析返回的配置数据
          const configList = response.data || [];
          this.configFormItemList = configList;
          this.configFormItemList.forEach((item) => {
            let target = this.marketConfigList&&this.marketConfigList.find((marketItem) => marketItem.type === item.ruleId);
            if (target) {
              let applicablePersons = target.configExtends.find((item) => item.type === 'applicablePersons');
              if(applicablePersons){
                if(applicablePersons.value && (applicablePersons.value.includes('ALL') || applicablePersons.value.includes('all'))) {
                   this.applicablePersonnel.value = 1;
                   this.applicablePersonnel.personValue = applicablePersons.value && applicablePersons.value.split(',');
                } else {
                   this.applicablePersonnel.value = 2;
                   this.applicablePersonnel.personValue = applicablePersons.value && applicablePersons.value.split(',');
                }
               
                console.log('applicablePersons----', applicablePersons, this.applicablePersonnel);
                
              }
              
              this.$set(item, 'value', target.value);
              this.$set(item, 'marketItemId', target.id);
            } else {
              this.$set(item, 'value', item.isDefaultEnabled ? 'true' : 'false');
              this.$set(item, 'marketItemId', null);
            }
          })
          console.log('postPersonalizedCheckTypeConfig----', configList);
        }
        
      } catch (error) {
        console.error("应用名称联动查询 业务列表失败：", error);
      } finally {
        this.isLoading = false;
      }
    },
    async getSpecialBusinessList() {
      try {
        this.isLoading = true;
        const response = await getSpecialBusinessListByPlatformName({
          platformName: "智能审单",
        });
        if (response.status && response.data) {
          // 解析返回的配置数据
          const configList = response.data || [];
          this.applicablePersonnel.configExtends[0].options = configList;
          console.log('configList----', configList);
        }
        
      } catch (error) {
        console.error("应用名称联动查询 业务列表失败：", error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 获取传单个性化配置
     */
    async getTransmissionConfig() {
      try {
        this.isLoading = true;
        const currentUser = await reqGetCurrentUser();
        this.currentUser = currentUser;
        const response = await productionOrderMarketConfigListByCondition({
          orgId: currentUser.orgId,
        });

        if (response.status && response.data) {
          // 解析返回的配置数据
          const configList = response.data || [];
          this.marketConfigList = configList;
          // 适用人员配置
          const applicablePersonnelConfig = configList.find(
            (item) => item.type === "applicablePersonnel",
          );
          if (applicablePersonnelConfig) {
            // 保存完整的配置对象
            this.applicablePersonnel = JSON.parse(
              JSON.stringify(applicablePersonnelConfig),
            );
          } else {
            // 如果没有配置，创建默认配置
            this.applicablePersonnel = {
              orgId: currentUser.orgId,
              type: "applicablePersonnel",
              value: 2,
              configExtends: [{options: []}],
              description: "适用人员",
              personValue: ['C级设计师'],
            };
          }
          // 订单重复风险检测配置
          const orderDuplicationRiskCheckConfig = configList.find(
            (item) => item.type === "orderDuplicationRiskCheck",
          );
          if (orderDuplicationRiskCheckConfig) {
            // 保存完整的配置对象
            this.orderDuplicationRiskCheckConfig = JSON.parse(
              JSON.stringify(orderDuplicationRiskCheckConfig),
            );
          } else {
            // 如果没有配置，创建默认配置
            this.orderDuplicationRiskCheckConfig = {
              orgId: currentUser.orgId,
              type: "orderDuplicationRiskCheck",
              value: "false",
              configExtends: [],
              description: "订单重复风险检测",
            };
          }

          // 订单尺寸超长超宽检测配置
          const orderSizeCheckConfig = configList.find(
            (item) => item.type === "orderSizeCheck",
          );
          if (orderSizeCheckConfig) {
            // 保存完整的配置对象
            this.orderSizeCheckConfig = JSON.parse(
              JSON.stringify(orderSizeCheckConfig),
            );
          } else {
            // 如果没有配置，创建默认配置
            this.orderSizeCheckConfig = {
              orgId: currentUser.orgId,
              type: "orderSizeCheck",
              value: "false",
              configExtends: [],
              description: "订单尺寸超长超宽检测",
            };
          }

          // 顶柜当吊柜使用检测
          const topAsHangingCabinetCheckConfig = configList.find(
            (item) => item.type === "topAsHangingCabinetCheck",
          );
          if (topAsHangingCabinetCheckConfig) {
            // 保存完整的配置对象
            this.topAsHangingCabinetCheckConfig = JSON.parse(
              JSON.stringify(topAsHangingCabinetCheckConfig),
            );
          } else {
            // 如果没有配置，创建默认配置
            this.topAsHangingCabinetCheckConfig = {
              orgId: currentUser.orgId,
              type: "topAsHangingCabinetCheck",
              value: "false",
              configExtends: [],
              description: "顶柜当吊柜使用检测",
            };
          }

          // 门板/装饰板突出圆弧台面检测
          const panelProtrudingCurvedTabletopCheckConfig = configList.find(
            (item) => item.type === "panelProtrudingCurvedTabletopCheck",
          );
          if (panelProtrudingCurvedTabletopCheckConfig) {
            // 保存完整的配置对象
            this.panelProtrudingCurvedTabletopCheckConfig = JSON.parse(
              JSON.stringify(panelProtrudingCurvedTabletopCheckConfig),
            );
          } else {
            // 如果没有配置，创建默认配置
            this.panelProtrudingCurvedTabletopCheckConfig = {
              orgId: currentUser.orgId,
              type: "panelProtrudingCurvedTabletopCheck",
              value: "false",
              configExtends: [],
              description: "门板/装饰板突出圆弧台面检测",
            };
          }

          // 侧封板与门板/顶封板高度不平齐检测
          const sideAndTopPanelHeightUnevennessCheckConfig = configList.find(
            (item) => item.type === "sideAndTopPanelHeightUnevennessCheck",
          );
          if (sideAndTopPanelHeightUnevennessCheckConfig) {
            // 保存完整的配置对象
            this.sideAndTopPanelHeightUnevennessCheckConfig = JSON.parse(
              JSON.stringify(sideAndTopPanelHeightUnevennessCheckConfig),
            );
          } else {
            // 如果没有配置，创建默认配置
            this.sideAndTopPanelHeightUnevennessCheckConfig = {
              orgId: currentUser.orgId,
              type: "sideAndTopPanelHeightUnevennessCheck",
              value: "false",
              configExtends: [],
              description: "侧封板与门板/顶封板高度不平齐检测",
            };
          }
        }
      } catch (error) {
        console.error("获取传单个性化配置失败：", error);
        this.$message.error("获取配置失败");
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 刷新数据
     */
    refreshData() {
      this.getTransmissionConfig();
    },
    /**
     * 获取尺寸配置值
     * @param {String} type - length/width/height
     */
    getSizeValue(type) {
      if (
        !this.orderSizeCheckConfig ||
        !this.orderSizeCheckConfig.configExtends
      ) {
        return null;
      }
      const config = this.orderSizeCheckConfig.configExtends.find(
        (item) => item.type === type,
      );
      return config && config.value ? Number(config.value) : null;
    },
    /**
     * 设置尺寸配置值
     * @param {String} type - length/width/height
     * @param {Number} value - 值
     */
    setSizeValue(type, value) {
      if (!this.orderSizeCheckConfig) {
        return;
      }
      if (!this.orderSizeCheckConfig.configExtends) {
        this.orderSizeCheckConfig.configExtends = [];
      }

      const config = this.orderSizeCheckConfig.configExtends.find(
        (item) => item.type === type,
      );

      const descriptionMap = {
        length: "长",
        width: "宽",
        height: "深",
      };

      if (config) {
        // 更新现有配置
        config.value = String(value);
      } else {
        // 添加新配置
        this.orderSizeCheckConfig.configExtends.push({
          type: type,
          value: String(value),
          options: null,
          priority: null,
          description: descriptionMap[type],
        });
      }
    },
    /**
     * 保存数据 - 供父组件调用
     */
    async saveData() {
      try {
        // 验证配置
        if (!this.validate()) {
          return;
        }

        this.isLoading = true;
        let configFormItemList = this.configFormItemList.map(i=>{
          return {
              orgId: this.currentUser&&this.currentUser.orgId,
              type: i.ruleId,
              value: i.value,
              id: i.marketItemId,
              configExtends: [],
              description: i.formDisplayTitle,
            }
        });
        let arr = [this.orderDuplicationRiskCheckConfig, this.orderSizeCheckConfig,...configFormItemList]
        if(this.applicablePersonnel.value === 1) {
          arr.forEach(item => {
            item.configExtends = item.configExtends.filter((config) => config.type !== "applicablePersons");
            item.configExtends.push({
              type: "applicablePersons",
              value: 'ALL',
              options: null,
              priority: null,
              description: "适用人员",
            })
          })
        } else if(this.applicablePersonnel.value === 2 && this.applicablePersonnel.personValue.length > 0) {
          arr.forEach(item => {
             item.configExtends = item.configExtends.filter((config) => config.type !== "applicablePersons");
            item.configExtends.push({
              type: "applicablePersons",
              value: this.applicablePersonnel.personValue.join(','),
              options: null,
              priority: null,
              description: "适用人员",
            })
          })
        }
        // 构建保存参数
        const params = [...arr];

        // 使用完整的配置对象，保留ID等字段用于更新
        // params.push(this.orderDuplicationRiskCheckConfig);
        // params.push(this.orderSizeCheckConfig);
        // params.push(this.topAsHangingCabinetCheckConfig);
        // params.push(this.panelProtrudingCurvedTabletopCheckConfig);
        // params.push(this.sideAndTopPanelHeightUnevennessCheckConfig);

        const res = await productionOrderMarketConfigSaveOrgConfig(params);

        if (!res.status) {
          throw new Error(res.message || "保存失败");
        }
        return res;
      } catch (error) {
        console.error("保存传单个性化配置失败：", error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 验证配置 - 供父组件调用
     */
    validate() {
      if(this.applicablePersonnel.value === 2 && this.applicablePersonnel.personValue.length === 0) {
        this.$message.error("请选择适用人员");
        return false;
      }
      // 如果开启了尺寸超限校验，需要验证尺寸参数
      if (
        this.orderSizeCheckConfig &&
        this.orderSizeCheckConfig.value === "true"
      ) {
        const configExtends = this.orderSizeCheckConfig.configExtends || [];
        const lengthConfig = configExtends.find(
          (item) => item.type === "length",
        );
        const widthConfig = configExtends.find((item) => item.type === "width");
        const heightConfig = configExtends.find(
          (item) => item.type === "height",
        );

        const length =
          lengthConfig && lengthConfig.value
            ? Number(lengthConfig.value)
            : null;
        const width =
          widthConfig && widthConfig.value ? Number(widthConfig.value) : null;
        const height =
          heightConfig && heightConfig.value
            ? Number(heightConfig.value)
            : null;

        if (
          length === null ||
          length === undefined ||
          width === null ||
          width === undefined ||
          height === null ||
          height === undefined
        ) {
          this.$message.error("订单尺寸超限提醒校验已开启，请填写长、宽、深");
          return false;
        }

        // 验证是否为大于0的数字
        if (length <= 0 || width <= 0 || height <= 0) {
          this.$message.error("长、宽、深必须为大于0的数字");
          return false;
        }
      }

      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.transmission-personalized-setting {
  > .title {
    color: var(--color-primary);
    font-size: 16px;
    font-weight: bold;
    border-left: 4px solid var(--color-primary);
    padding-left: 5px;
    .transmission-applicable-personnel-setting {
      margin-left: 10px;
      color: #333;
      font-size: 14px;
      font-weight: normal;
    }
  }
  > .setting-item {
    background-color: #f1f1f1;
    padding: 10px;
    margin: 10px 0;

    .config-row {
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .config-header {
        display: flex;
        align-items: center;
        line-height: 2.5em;
        gap: 10px;

        > span:first-child {
          flex-shrink: 0;
          font-weight: bold;
        }

        .size-inputs {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-left: 10px;

          .input-group {
            display: flex;
            align-items: center;
            gap: 5px;

            .input-label {
              white-space: nowrap;
              font-size: 14px;
            }

            .input-unit {
              white-space: nowrap;
              font-size: 14px;
            }
          }
        }
      }

      .config-description {
        color: #666;
        font-size: 14px;
        line-height: 1.6;
        padding: 5px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// transmissionPersonalizedSetting.vue?17421c52